import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';
import Link from '../Link/Link';

const AppDownloadLinks = () => {
  const dynamicUrl = isMobile && process.env.NEXT_PUBLIC_DYNAMIC_APP_URL;
  const appStoreUrl = process.env.NEXT_PUBLIC_APP_STORE_URL || '#';
  const googlePlayStoreUrl = process.env.NEXT_PUBLIC_GOOGLE_PLAY_STORE_URL || '#';
  const { t } = useTranslation();

  const router = useRouter();
  const isLocaleEN = router.locale === 'en';

  return (
    <div className="w-max">
      <p className="pb-2 text-center font-medium">
        ＼ {t('component:app_download_links.title')} ／
      </p>
      <div className="flex justify-center pb-6">
        <Link href={dynamicUrl || appStoreUrl} prefetch={false}>
          <a target="_blank" rel="noopener" className="flex">
            <Image
              src={isLocaleEN ? '/app-store-badge-en.svg' : '/app-store-badge.svg'}
              alt="App store badge"
              width={86}
              height={32}
            />
          </a>
        </Link>
        <Link href={dynamicUrl || googlePlayStoreUrl} prefetch={false}>
          <a target="_blank" rel="noopener" className="flex">
            <Image
              src={isLocaleEN ? '/google-play-badge-en.svg' : '/google-play-badge.svg'}
              alt="Google Play store badge"
              width={108}
              height={32}
            />
          </a>
        </Link>
      </div>
    </div>
  );
};

export default AppDownloadLinks;
